import { render, staticRenderFns } from "./honoraryAwards.vue?vue&type=template&id=2f44382a"
import script from "./honoraryAwards.vue?vue&type=script&lang=js"
export * from "./honoraryAwards.vue?vue&type=script&lang=js"
import style0 from "./honoraryAwards.vue?vue&type=style&index=0&id=2f44382a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports